import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'

import { setCockpitInitiativesView } from '../../model'
import { CockpitFilterSummary } from '../components/cockpitFilterSummary'
import { CockpitTileTitle } from '../components/cockpitTileTitle'

import { CockpitInitiativesViewSwitch } from './components'

type CockpitKeyInitiativesTitleProps = {
  title: string
  expanded: boolean
  onToggle: () => void
  /** `data-tour-id` for the view switch. Both cockpits open this tile, and each tour targets the
   *  switch by its own id. */
  viewSwitchTourId?: string
  isManagerCockpitMode?: boolean
}

export const CockpitKeyInitiativesTitle = ({
  title,
  expanded,
  onToggle,
  viewSwitchTourId,
  isManagerCockpitMode = false,
}: CockpitKeyInitiativesTitleProps) => {
  const dispatch = useAppDispatch()

  /** Expanding from the title always means the lists — only the collapsed tile's score asks for
   *  the quality view, so this resets what a previous click may have left behind. */
  const handleToggle = () => {
    if (!expanded) {
      dispatch(setCockpitInitiativesView('initiatives'))
    }

    onToggle()
  }

  return (
    <CockpitTileTitle
      title={title}
      expanded={expanded}
      onToggle={handleToggle}
      actions={
        /* The views are the expanded tile's own: collapsed, the tile shows its summary only. */
        expanded ? (
          <CockpitInitiativesViewSwitch
            tourId={viewSwitchTourId}
            isManagerCockpitMode={isManagerCockpitMode}
          />
        ) : undefined
      }
    >
      <CockpitFilterSummary
        expanded={expanded}
        bordered={false}
        offering
        category
        period
        metric
        currency
      />
    </CockpitTileTitle>
  )
}

CockpitKeyInitiativesTitle.displayName = 'CockpitKeyInitiativesTitle'
